import React, { Component } from "react";
import { translate } from "react-polyglot";
import Select from "react-select";
import { OptionsType, ValueType } from "react-select/lib/types";

interface IOption {
  label: string;
  value: string;
}

interface IState {
  selectedValue: ValueType<IOption>;
}
const initialState: IState = {
  selectedValue: {} as ValueType<IOption>
};

interface ICustomSelectProps {
  options: OptionsType<IOption>;
  defaultValue?: ValueType<IOption>;
  fieldName: string;
  value: string;
  handleSelect: (key: string) => void;
}

class CustomSelect extends Component<
  ICustomSelectProps & TranslateProps,
  IState
> {
  constructor(props: ICustomSelectProps & TranslateProps) {
    super(props);

    this.state = initialState;
    this.onChange = this.onChange.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  public componentWillMount() {
    const { defaultValue, handleSelect } = this.props;

    if (defaultValue) {
      if (Array.isArray(defaultValue)) {
        return;
      }
      // @ts-ignore
      handleSelect(defaultValue.value);
    }
  }

  public onChange(option: ValueType<IOption>) {
    const { handleSelect } = this.props;
    if (Array.isArray(option)) {
      return;
    }

    if (handleSelect) {
      // @ts-ignore
      handleSelect(option.value);
    }
  }

  public getValue() {
    const { options, value } = this.props;

    return options.find(o => o.value === value);
  }

  public render() {
    const { fieldName, t, options, value } = this.props;

    return (
      <React.Fragment>
        <label htmlFor={fieldName}>{t(`parameters.${fieldName}`)}</label>

        <Select
          name={fieldName}
          value={options.find(o => o.value === value) || null}
          onChange={this.onChange}
          options={options}
        />
      </React.Fragment>
    );
  }
}

export default translate()(CustomSelect);
